module.exports = __webpack_public_path__ + "img/email.30b0662b.svg";